import TypedNativeModules from "../internal/TypedNativeModules";
import type { OpenLoginModalResult } from "../types/TareBridge";

export default async function openLoginModal(
  isRegistration: boolean,
  from?: string,
): Promise<OpenLoginModalResult> {
  const openLoginModal = TypedNativeModules.RNTareBridge?.openLoginModal;
  if (typeof openLoginModal === "function") {
    return await openLoginModal(isRegistration, from);
  }
  return Promise.reject("openLoginModal not available");
}
